import axios from 'axios';
import { PRODUCT_ENQUIRY } from '@/config/platformtype';

/**
 * 搜索附近店铺
 */
export function searchNearbyStores(params) {
  return axios({
    url: '/mall/search/nearby/store',
    method: 'get',
    params: {
      ...params,
      platformType: PRODUCT_ENQUIRY,
    },
  });
}

